module.exports = __webpack_public_path__ + "static/paris-010.thumb-b884cf11c27939b45ab2109b5d77152a.jpg";